export default __webpack_public_path__ + "static/media/spartan_form_bg.496a413e.png";